import { useMutation, UseMutationOptions } from 'react-query-v5';
import api from '../api';
import { CreateReviewDto } from '../api-client';

export const useCreateReview = (
  options?: UseMutationOptions<CreateReviewDto, Error, CreateReviewDto>
) =>
  useMutation({
    ...options,
    mutationFn: async ({ ...data }) =>
      api.review.reviewControllerCreateReview(data),
  });
